// App-brede Excel-achtige navigatie: pijltje omhoog/omlaag springt naar het
// invoerveld in de regel erboven/eronder (zelfde kolom), in ELKE tabel.
// De gedeelde <Table>-component heeft z'n eigen handler; die roept preventDefault
// aan, dus we slaan die gevallen hier over (e.defaultPrevented).
export function installGridArrowNav() {
  if (typeof document === "undefined" || window.__gridNavInstalled) return;
  window.__gridNavInstalled = true;

  document.addEventListener("keydown", (e) => {
    if (e.defaultPrevented) return;
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    const el = document.activeElement;
    if (!el || el.tagName !== "INPUT") return;
    const type = (el.getAttribute("type") || "text").toLowerCase();
    if (["checkbox", "radio", "range", "color", "file", "button", "submit", "reset"].includes(type)) return;
    if (el.hasAttribute("list")) return; // autocomplete-veld met suggesties

    const table = el.closest("table");
    if (!table) return;
    const scope = el.closest("tbody") || table;

    const fields = Array.prototype.filter.call(
      scope.querySelectorAll("input"),
      (f) => !f.disabled && !f.readOnly && f.type !== "hidden" && f.offsetParent !== null && !f.hasAttribute("list")
    );
    if (fields.length < 2) return;

    const cur = el.getBoundingClientRect();
    const cx = cur.left + cur.width / 2;
    const cy = cur.top + cur.height / 2;
    const down = e.key === "ArrowDown";

    let best = null;
    let bestScore = Infinity;
    for (const f of fields) {
      if (f === el) continue;
      const r = f.getBoundingClientRect();
      const fy = r.top + r.height / 2;
      const dy = fy - cy;
      if (down ? dy <= 3 : dy >= -3) continue; // moet echt onder/boven staan
      const fx = r.left + r.width / 2;
      const score = Math.abs(dy) + Math.abs(fx - cx) * 4; // kolom-uitlijning zwaar wegen
      if (score < bestScore) { bestScore = score; best = f; }
    }

    if (best) {
      e.preventDefault();
      best.focus();
      if (typeof best.select === "function") { try { best.select(); } catch (_) { /* noop */ } }
    } else if (type === "number") {
      e.preventDefault(); // voorkom in elk geval op-/aftellen op de laatste regel
    }
  }, false);
}
